import axiosInstance from "../../services/axiosInstance";

export const loginApi = async (data) => {
    const response = await axiosInstance.post("/login", data);
    return response.data;
};

export const profileApi = async (token) => {
    const response = await axiosInstance.get("/profile", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const stagingProdApi = async (
    token,
    params = null,
    url = "/staging-production"
) => {
    const response = await axiosInstance.get(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params,
    });

    return response.data;
};

export const listPaletteApi = async (token, params) => {
    const response = await axiosInstance.get("/bins", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            page: params.page,
            per_page: params.per_page,
            search: params.search
        }, 
    });

    return response.data;
};


export const addPaletteApi = async (data) => {
    const response = await axiosInstance.post("/bins-store", data);
    return response.data;
};

export const listRakApi = async (token, params) => {
    const response = await axiosInstance.get("/racks", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            page: params.page,
            per_page: params.per_page,
            search: params.search
        },
    });

    return response.data;
};

export const addRakApi = async (data) => {
    const response = await axiosInstance.post("/racks-store", data);
    return response.data;
};

export const listProductApi = async (token, params) => {
    const response = await axiosInstance.get("/products", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            page: params.page,
            per_page: params.per_page,
            search: params.search
        },
    });

    return response.data;
};

export const addProductApi = async (data) => {
    const response = await axiosInstance.post("/products-store", data);
    return response.data;
};

export const listWarehouseApi = async (token) => {
    const response = await axiosInstance.get("/warehouses", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const updateRacksProductApi = async (id, data, token) => {
    const response = await axiosInstance.put(`/racks/${id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};



